import { type ComponentProps } from 'react';
import { MenuItems } from '@headlessui/react';
import clsx from 'clsx';

import styles from './Dropdown.module.css';

type DropdownItemsProps = ComponentProps<typeof MenuItems>;

export default function DropdownItems({ anchor = 'bottom end', className, children, ...props }: DropdownItemsProps) {
  return (
    <MenuItems
      anchor={anchor}
      className={clsx(styles.dropdownItems, className)}
      {...props}
    >
      {children}
    </MenuItems>
  );
}
